// import { stringify as stringifyQs } from "qs";
import { stringifyQs } from "@saleor/utils/urls";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  SingleAction,
  Sort,
  TabActionDialog
} from "../types";

export const rotarySection = "/rotary/";
export const rotaryListPath = rotarySection;
export enum RotaryListUrlFiltersEnum {
  number = "number",
  isEnable = "isEnable",
  query = "query"
}
export enum RotaryListUrlSortField {
  name = "name",
  number = "number",
  isEnable = "isEnable",
  createDate = "createDate",
  startDate = "startDate",
  endDate = "endDate"
}
export type RotaryListUrlFilters = Filters<RotaryListUrlFiltersEnum>;
export type RotaryListUrlSort = Sort<RotaryListUrlSortField>;
export type RotaryListUrlDialog = "remove" | TabActionDialog;

export type RotaryListUrlQueryParams = ActiveTab &
  RotaryListUrlFilters &
  RotaryListUrlSort &
  BulkAction &
  Dialog<RotaryListUrlDialog> &
  Pagination;
export const rotaryListUrl = (params?: RotaryListUrlQueryParams) =>
  rotaryListPath + "?" + stringifyQs(params);

export type RotaryUrlDialog =
  | "add-value"
  | "edit-value"
  | "remove"
  | "remove-value"
  | "remove-values";

export type RotaryUrlQueryParams = BulkAction &
  Dialog<RotaryUrlDialog> &
  SingleAction;

export const rotaryPath = (id: string) => urlJoin(rotarySection, id);

export type RotaryAddUrlDialog =
  | "add-value"
  | "edit-value"
  | "remove-value"
  | "remove-values";
export type RotaryAddUrlQueryParams = Dialog<RotaryAddUrlDialog> & SingleAction;

export const rotaryAddPath = urlJoin(rotarySection, "add");

export const rotaryAddUrl = (params?: RotaryAddUrlQueryParams) =>
  rotaryAddPath + "?" + stringifyQs(params);

export const rotaryUrl = (id: string, params?: RotaryUrlQueryParams) =>
  rotaryPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
